import { AutoMap } from "@automapper/classes";
import { CassetteDTO } from "./cassette.dto";
import { PompeDTO } from "./pompe.dto";
import { SecuriteDTO } from "./securite.dto";
import { ZoneSamplingConditionDTO } from "./zone-sampling-condition.dto";

export class ZoneMeasureDTO {
    @AutoMap()
    samplingId!: number;
    @AutoMap()
    code!: string;
    @AutoMap()
    isCancelled!: boolean;
    @AutoMap()
    measureReferenceCode!: string;
    @AutoMap()
    measureReferenceName!: string;
    @AutoMap()
    status!: number;
    @AutoMap()
    localisation!: string;
    @AutoMap()
    textColor!: string;
    @AutoMap()
    color!: string;

    @AutoMap()
    observation?: string;
    @AutoMap()
    pumpWithBattery?: string;
    @AutoMap()
    isDepose!: boolean;
    
    @AutoMap()
    cassette!: CassetteDTO;

    @AutoMap()
    poseSecurite!: SecuriteDTO;
    @AutoMap()
    deposeSecurite!: SecuriteDTO;
    @AutoMap()
    zoneSamplingCondition!: ZoneSamplingConditionDTO;
    @AutoMap()
    hasFan!: boolean;

    @AutoMap()
    sampleCode?: string;
}